// PDF React View
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
const TypeSignDigitalModal = props => {
  const TYPE_SIGN = {
    HSM: "HSM",
    USB: "USB",
  };
  const dispatch = useDispatch();
  const {
    isOpen,
    toggle,
    t,
    toggleUSBSignModal,
    toggleHSMSignModal,
    transferData,
    downloadXmlFunc,
  } = props;
  const [typeSign, setTypeSign] = useState(TYPE_SIGN.HSM);
  const { listMethodSign, loadListMethodSign } = useSelector(
    state => state.Dashboard
  );

  useEffect(() => {
    if (isOpen) {
      checkMethodSign();
      setTypeSign(TYPE_SIGN.HSM);
    }
  }, [isOpen]);

  const checkMethodSign = () => {
    // Nếu chỉ có 1 method thì hiện lun
    if (listMethodSign.length === 1) {
      const code = listMethodSign[0].code;
      setTimeout(() => {
        toggle();
      });
      switch (code) {
        case "hsm":
          toggleHSMSignModal();
          break;
        case "usb":
          dispatch(downloadXmlFunc(transferData.resource_id, "test", "text"));
          toggleUSBSignModal();
          break;
        default:
          break;
      }
    }
  };

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>{t("typeSign.title")}</Label>
        </ModalHeader>
        {loadListMethodSign ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="2"
              countButton="2"
              formClass="row-cols-1 row-cols-md-1"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              {listMethodSign.length === 2 ? (
                <React.Fragment>
                  <Row>
                    <Col>
                      <Label
                        style={{ cursor: "pointer" }}
                        className="d-flex align-items-center gap-1"
                      >
                        <input
                          type="radio"
                          name="typeSign"
                          value={typeSign}
                          checked={typeSign === TYPE_SIGN.HSM}
                          onChange={() => {
                            setTypeSign(TYPE_SIGN.HSM);
                          }}
                        ></input>
                        {t("typeSign.signHSM")}
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label
                        style={{ cursor: "pointer" }}
                        className="d-flex align-items-center gap-1"
                      >
                        <input
                          type="radio"
                          name="typeSign"
                          value={typeSign}
                          checked={typeSign === TYPE_SIGN.USB}
                          onChange={() => {
                            setTypeSign(TYPE_SIGN.USB);
                          }}
                        ></input>
                        {t("typeSign.signUSB")}
                      </Label>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : (
                <Row>
                  <Label className="text-danger">
                    Không có phương thức ký số hợp lệ. Vui lòng chọn đơn vị khác
                  </Label>
                </Row>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="primary"
                className="me-2"
                disabled={listMethodSign.length === 0}
                onClick={() => {
                  toggle();
                  switch (typeSign) {
                    case TYPE_SIGN.HSM:
                      toggleHSMSignModal();
                      break;
                    case TYPE_SIGN.USB:
                      dispatch(
                        downloadXmlFunc(
                          transferData.resource_id,
                          "test.xml",
                          "text"
                        )
                      );
                      toggleUSBSignModal();
                      break;
                    default:
                      break;
                  }
                }}
              >
                {t("typeSign.select")}
              </Button>
              <Button
                type="button"
                color="danger"
                className="me-2"
                onClick={toggle}
              >
                {t("typeSign.close")}
              </Button>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

TypeSignDigitalModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  t: PropTypes.any,
  transferData: PropTypes.any,
  toggleUSBSignModal: PropTypes.any,
  toggleHSMSignModal: PropTypes.any,
  downloadXmlFunc: PropTypes.any,
};

export default TypeSignDigitalModal;
